import { DonateHero, DonateOptions } from '@/components/sections/donate-page'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const DonatePage = () => {
  usePageTitle('Donate')

  return (
    <>
      <DonateHero />
      <DonateOptions />
      <FinalCTA />
    </>
  )
}
